import { savedSuggestionSelection } from '@shared/canvasSuggestion';
import type { CanvasChatMessage } from './canvas-types';

/** A consumed product answer is represented by the chip on its own question.
 * Keep the original request and full transport answer in the transcript. */
export function isResolvedProductChoiceReply(message: CanvasChatMessage, messages: CanvasChatMessage[]): boolean {
  if (message.role !== 'user') return false;
  const index = messages.findIndex(entry => entry.id === message.id);
  if (index < 1) return false;
  const source = messages.slice(0, index).reverse().find(entry => entry.role === 'assistant' || entry.role === 'user');
  const choices = source?.suggestionPills;
  if (!source || source.role !== 'assistant' || !choices) return false;
  const productChoice = /\bproduct\b/i.test(choices.question) || choices.pills.some(pill => pill.productId != null || pill.forcedTool?.arguments.productId != null);
  if (!productChoice) return false;
  const selection = savedSuggestionSelection(source, messages);
  return !!selection && selection.value === message.content && choices.pills.some(pill => pill.value === message.content);
}
